import Typography from 'components/global/Typography';

import * as S from './CurrencyViewer.styled';

const CurrencyViewerBold = ({ data, value }) => {
	const isFreeShipmentCredit =
		data.transactionType === 'freeShipmentCredit' ||
		data.transactionType === 'freeShipmentCreditUpdate' ||
		data.transactionType === 'otoFeeFreeShipment' ||
		data.transactionType === 'otoFeeFreeShipmentEnterprise';

	return (
		<S.CurrencyContainer>
			<Typography fontWeight="700" withCurrency={!isFreeShipmentCredit} currency={data?.currency}>
				{value}
			</Typography>
			{isFreeShipmentCredit && (
				<>
					<Typography>&nbsp;</Typography>
					<Typography fontWeight="700">shipments</Typography>
				</>
			)}
		</S.CurrencyContainer>
	);
};

export default CurrencyViewerBold;
